<h2 mat-dialog-title class="m-0">Organization Change Log
    <!-- Close button. -->
    <button mat-icon-button mat-dialog-close class="close-button">
        <mat-icon>close</mat-icon>
    </button>
</h2>

<mat-dialog-content class="h-100-70 w-100">
    
    <div class="view-container m-3 w-100">
        <div class="view-header">
            <span class="viewer-title-spacer mb-3"></span>

            <mat-form-field class="mw-300" appearance="outline">
                <mat-label>Search</mat-label>
                <input matInput (keyup)="applyFilter($event)" placeholder="Search..." />
                <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
        </div>

        <div class="view-content pt-0">
            <mat-table [dataSource]="dataSource" class="mat-elevation-z5 w-100">

                @for(column of columnsWithoutActions; track column) {
                <ng-container [matColumnDef]="column.columnDef">
                    <mat-header-cell *matHeaderCellDef>{{column.header}}</mat-header-cell>
                    <mat-cell *matCellDef="let row">{{column.cell(row)}}</mat-cell>
                </ng-container>
                }

                <ng-container matColumnDef="actions">
                    <mat-header-cell *matHeaderCellDef class="flex-right mw-5-5rem">Actions </mat-header-cell>
                    <mat-cell *matCellDef="let row" class="flex-right mw-5-5rem">
                        <button mat-icon-button aria-label="Open actions" [disabled]="columnActions.length === 0" [matMenuTriggerFor]="menu">
                            <mat-icon>more_vert</mat-icon>
                        </button>

                        <mat-menu #menu="matMenu">
                            @for(opt of columnActions; track opt) {
                            <button mat-menu-item [attr.color]="opt.color" [disabled]="opt.disabled"
                                (click)="opt.action(row)">{{opt.display}}</button>
                            }
                        </mat-menu>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row matRipple *matRowDef="let row; columns: displayedColumns;" class="task" [ngClass]="row.status" (dblclick)="openNotification(row)"></mat-row>
            </mat-table>
        </div>
    </div>

</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>